import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND, NAV_LINKS } from "../data/content";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAF7F2]/85 border-b border-[#E8D8C8]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-24 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center">
          <img
            src={BRAND.logoBrown}
            alt="Stories — The Millet Café"
            className="h-20 w-20 sm:h-24 sm:w-24 object-contain"
          />
        </Link>

        <ul className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm tracking-wide link-underline transition-colors ${
                    isActive ? "text-[#C76D4B]" : "text-[#4A3320] hover:text-[#C76D4B]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/contact" data-testid="navbar-reserve-btn" className="btn-primary text-sm">
            Reserve a Corner
          </Link>
        </div>

        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 rounded-full border border-[#E8D8C8] text-[#4A3320]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="lg:hidden bg-[#FAF7F2] border-t border-[#E8D8C8] px-5 py-6"
        >
          <ul className="flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `block py-2 text-lg font-serif-display ${
                      isActive ? "text-[#C76D4B]" : "text-[#4A3320]"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <Link to="/contact" data-testid="mobile-reserve-btn" className="btn-primary mt-6 w-full justify-center">
            Reserve a Corner
          </Link>
        </div>
      )}
    </header>
  );
}
